export var RoomSecurity;
(function (RoomSecurity) {
    RoomSecurity["public"] = "public";
    RoomSecurity["secure"] = "secure";
})(RoomSecurity || (RoomSecurity = {}));
